import React, { forwardRef } from 'react';
import classNames from 'classnames';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid = false, disabled = false, rows = 3, ...rest }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      disabled={disabled}
      className={classNames(
        'ecme-input',
        {
          'ecme-input-invalid': invalid,
          'ecme-input-disabled': disabled,
        },
        className
      )}
      {...rest}
    />
  )
);

Textarea.displayName = 'Textarea';

export default Textarea;
